import { endpointLabel } from './route-endpoints';

/**
 * The left column's "get started" state — a new plan whose one route has no
 * line yet (see components/PlanTrailGetStarted.vue). Pure.
 */

type Coord = [number, number];

/** A route still being started: no line between a start and an end yet. */
export function routeNeedsEndpoints(route: { markers?: unknown[] } | null | undefined): boolean {
  return (route?.markers?.length ?? 0) < 2;
}

/**
 * A plan that hasn't been started: no routes, or just one with no line yet.
 * (Routes missing from the store — `undefined` — count as not started.)
 */
export function planNeedsStart(routes: Array<{ markers?: unknown[] } | null | undefined>): boolean {
  return routes.length === 0 || (routes.length === 1 && routeNeedsEndpoints(routes[0]));
}

/**
 * Where a Start or End search looks around: the start once it's set, or
 * else wherever the map is looking.
 */
export function endpointSearchFocus(startCoord: Coord | null, mapCentre: Coord | null): Coord | null {
  return startCoord ?? mapCentre;
}

/**
 * What the Start field shows once a start exists: the place or address it
 * was picked as, or its address once looked up, or its coordinates — and
 * nothing while there's no start.
 */
export function startFieldLabel(input: { coordinates: Coord | null; pickedName?: string | null; address?: string | null }): string | null {
  if (!input.coordinates) return null;
  return endpointLabel({ destinationName: input.pickedName, address: input.address, coordinates: input.coordinates });
}

/**
 * Whether a field offers "use my location": the Start always; the End only
 * while the start wasn't set from it — a hike out from where you are and
 * back to it is a loop, not a route.
 */
export function offersCurrentLocation(which: 'start' | 'end', locationUsedFor: 'start' | 'end' | null): boolean {
  if (which === 'start') return locationUsedFor !== 'end';
  return locationUsedFor !== 'start';
}
